import { useState } from 'react';
import { estimerValeur } from '../utils/firestoreService';

const F = "'Inter',-apple-system,sans-serif";
const D = "'Bangers','Arial Black',cursive";

export default function ValeurEstimee({ bd }) {
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);

  const estimate = async () => {
    setLoading(true); setOpen(true);
    const r = await estimerValeur(bd);
    setResult(r); setLoading(false);
  };

  return (
    <div style={{marginTop:'10px'}}>
      {!open ? (
        <button onClick={estimate}
          style={{
            display:'flex',alignItems:'center',gap:'6px',
            padding:'9px 16px',border:'1.5px solid var(--border)',
            borderRadius:'10px',background:'#FFFBEB',
            fontFamily:F,fontSize:'13px',fontWeight:600,color:'#92400E',
            cursor:'pointer',width:'100%',justifyContent:'center',
            transition:'all .15s',
          }}
          onMouseOver={e=>{e.currentTarget.style.borderColor='#F5C842';e.currentTarget.style.background='#FEF9C3';}}
          onMouseOut={e=>{e.currentTarget.style.borderColor='var(--border)';e.currentTarget.style.background='#FFFBEB';}}>
          💰 Estimer la valeur de revente
        </button>
      ) : (
        <div style={{background:'#FFFBEB',border:'1px solid #FDE68A',borderRadius:'12px',padding:'14px',fontFamily:F}}>
          <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:'10px'}}>
            <div style={{fontFamily:D,fontSize:'1rem',letterSpacing:'.05em',color:'#92400E'}}>Estimation de valeur</div>
            <button onClick={()=>setOpen(false)} style={{background:'none',border:'none',cursor:'pointer',color:'var(--subtle)',fontSize:'16px',lineHeight:1,padding:'2px'}}>×</button>
          </div>

          {loading ? (
            <div style={{textAlign:'center',padding:'12px',color:'#92400E',fontSize:'13px'}}>
              <div style={{width:'20px',height:'20px',border:'2px solid #FDE68A',borderTopColor:'#F5C842',borderRadius:'50%',animation:'spin .7s linear infinite',display:'inline-block',marginBottom:'6px'}}/>
              <div>Calcul en cours…</div>
            </div>
          ) : result && (
            <>
              {/* Prix estimé */}
              <div style={{textAlign:'center',marginBottom:'12px'}}>
                <div style={{fontFamily:D,fontSize:'2rem',color:'#92400E',letterSpacing:'.04em',lineHeight:1}}>
                  {result.fourchette.low} – {result.fourchette.high} €
                </div>
                <div style={{fontSize:'12px',color:'#B45309',marginTop:'3px'}}>
                  Estimation centrale : <strong>{result.estimation} €</strong>
                </div>
              </div>

              {/* Sources */}
              <div style={{display:'flex',flexDirection:'column',gap:'6px',marginBottom:'10px'}}>
                {result.sources.map((s,i) => (
                  <div key={i} style={{background:'rgba(255,255,255,.6)',borderRadius:'8px',padding:'8px 10px',fontSize:'12px'}}>
                    <div style={{fontWeight:700,color:'#92400E',marginBottom:'2px'}}>{s.label}</div>
                    <div style={{color:'#A16207'}}>{s.detail}</div>
                    {s.prix && <div style={{fontWeight:700,color:'#92400E',marginTop:'3px'}}>{s.prix} €</div>}
                  </div>
                ))}
              </div>

              {/* Disclaimer */}
              <div style={{fontSize:'11px',color:'#B45309',lineHeight:1.5,borderTop:'1px solid #FDE68A',paddingTop:'8px'}}>
                ⚠️ Estimation indicative. Pour les vrais prix du marché, clique sur <strong>✓ eBay vendus</strong> — ce sont les transactions réellement conclues, pas les annonces en attente.
              </div>

              {/* Liens marché */}
              {(() => {
                const q = encodeURIComponent(
                  (bd.serie || bd.titre || '') + (bd.numero ? ' tome ' + bd.numero : '')
                );
                // eBay ventes terminées ET vendues = prix réels du marché
                const ebayVendues = `https://www.ebay.fr/sch/i.html?_nkw=${q}&LH_Complete=1&LH_Sold=1&LH_ItemCondition=4`;
                const ebayActives = `https://www.ebay.fr/sch/i.html?_nkw=${q}`;
                const rakuten     = `https://fr.shopping.rakuten.com/search?keyword=${q}`;
                const lbc         = `https://www.leboncoin.fr/recherche?text=${q}&category=7`;
                const linkStyle = {
                  fontSize:'11px', fontWeight:700, color:'#92400E',
                  background:'rgba(255,255,255,.7)', border:'1px solid #FDE68A',
                  borderRadius:'6px', padding:'4px 9px', textDecoration:'none',
                  transition:'background .15s', display:'inline-block',
                };
                return (
                  <div style={{display:'flex',gap:'6px',marginTop:'10px',flexWrap:'wrap'}}>
                    {/* eBay ventes vendues — LA référence prix réels */}
                    <a href={ebayVendues} target="_blank" rel="noopener noreferrer"
                      style={{...linkStyle,background:'#FEF9C3',border:'1.5px solid #CA8A04',color:'#713F12'}}
                      onMouseOver={e=>e.currentTarget.style.background='#FEF08A'}
                      onMouseOut={e=>e.currentTarget.style.background='#FEF9C3'}
                      title="Prix des exemplaires réellement vendus (pas juste en annonce)">
                      ✓ eBay vendus →
                    </a>
                    <a href={ebayActives} target="_blank" rel="noopener noreferrer"
                      style={linkStyle}
                      onMouseOver={e=>e.currentTarget.style.background='rgba(255,255,255,.95)'}
                      onMouseOut={e=>e.currentTarget.style.background='rgba(255,255,255,.7)'}>
                      eBay actif →
                    </a>
                    <a href={rakuten} target="_blank" rel="noopener noreferrer"
                      style={linkStyle}
                      onMouseOver={e=>e.currentTarget.style.background='rgba(255,255,255,.95)'}
                      onMouseOut={e=>e.currentTarget.style.background='rgba(255,255,255,.7)'}>
                      Rakuten →
                    </a>
                    <a href={lbc} target="_blank" rel="noopener noreferrer"
                      style={linkStyle}
                      onMouseOver={e=>e.currentTarget.style.background='rgba(255,255,255,.95)'}
                      onMouseOut={e=>e.currentTarget.style.background='rgba(255,255,255,.7)'}>
                      Le Bon Coin →
                    </a>
                  </div>
                );
              })()}
            </>
          )}
        </div>
      )}
      <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
    </div>
  );
}
